import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../Services/auth.guard';
import { TourComponent } from './tour.component';

const routesTour: Routes = [
  {
    path: '',
    component: TourComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      // {
      //   path: 'quick-transfer',
      //   loadChildren: () => import('../quick-transfer/quick-transfer.module').then(m => m.QuickTransferModule)
      // },
      {
        path: 'quick-transfer',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'buy-sell',
        loadChildren: () => import('../buy-sell/buy-sell.module').then(m => m.BuySellModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('../orders/orders.module').then(m => m.OrdersModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('../user-info/user-info.module').then(m => m.UserInfoModule)
      },
      // {
      //   path: 'wallet',
      //   loadChildren: () => import('../wallet/wallet.module').then(m => m.WalletModule)
      // },
      {
        path: 'wallet',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'deposit',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'withdrawals',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'whitelist',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
      // {
      //   path: 'deposit',
      //   loadChildren: () => import('../wallet/wallet.module').then(m => m.WalletModule)
      // },
      // {
      //   path: 'withdrawals',
      //   loadChildren: () => import('../wallet/wallet.module').then(m => m.WalletModule)
      // },
      // {
      //   path: 'whitelist',
      //   loadChildren: () => import('../wallet/wallet.module').then(m => m.WalletModule)
      // },
      // {
      //   path: 'transfer-history',
      //   loadChildren: () => import('../transfer-history/transfer-history.module').then(m => m.TransferHistoryModule)
      // },
      // {
      //   path: 'transfer-history/:tab',
      //   loadChildren: () => import('../transfer-history/transfer-history.module').then(m => m.TransferHistoryModule)
      // },
      {
        path: 'transfer-history',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
      {
        path: 'transfer-history/:tab',
        loadChildren: () => import('../send-receive/wallet.module').then(m => m.WalletModule)
      },
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routesTour)],
  exports: [RouterModule]
})
export class TourRoutingModule {
}

